import React, { useState } from 'react';
import axios from 'axios';
import './LoginModal.css';

const LoginModal = ({ onClose, onLogin, onRegister }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.username.trim()) {
      newErrors.username = 'Nome de usuário é obrigatório';
    }
    
    if (!formData.password.trim()) {
      newErrors.password = 'Senha é obrigatória';
    } else if (formData.password.length < 3) {
      newErrors.password = 'Senha deve ter pelo menos 3 caracteres';
    }
    
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submitted', formData);
    
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    setIsLoading(true);
    
    try {
      console.log('Sending login request...');
      const response = await axios.post('/api/auth/login', {
        username: formData.username,
        password: formData.password
      });
      
      console.log('Login response:', response.data);
      
      if (response.data.success) {
        onLogin(response.data.user);
        onClose(); // Fecha o modal após login bem-sucedido
      } else {
        setErrors({ general: response.data.message || 'Erro ao fazer login' });
      }
    } catch (error) {
      console.error('Login error:', error);
      if (error.response && error.response.data) {
        setErrors({ general: error.response.data.message || 'Erro ao fazer login' });
      } else {
        setErrors({ general: 'Erro de conexão. Tente novamente.' });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackdropClick = (e) => {
    // Só fecha se clicar diretamente no backdrop (não no modal)
    if (e.target === e.currentTarget) {
      // Não faz nada - modal não deve fechar ao clicar fora
      e.stopPropagation();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="login-modal">
        <div className="modal-header">
          <h2>Entrar no Portal</h2>
          <button className="close-button" onClick={onClose} aria-label="Fechar">
            ×
          </button>
        </div>
        
        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Usuário</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              className={errors.username ? 'error' : ''}
              placeholder="Digite seu usuário"
              disabled={isLoading}
            />
            {errors.username && <span className="error-message">{errors.username}</span>}
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className={errors.password ? 'error' : ''}
              placeholder="Digite sua senha"
              disabled={isLoading}
            />
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>
          
          {errors.general && <div className="error-general">{errors.general}</div>}
          
          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
            onClick={() => console.log('Login button clicked')}
          >
            {isLoading ? (
              <span className="button-content">
                <span className="spinner-small"></span>
                Entrando...
              </span>
            ) : (
              <span className="button-content">Entrar</span>
            )}
          </button>
        </form>
        
        <div className="modal-footer">
          <p>Esqueceu sua senha? <a href="#recuperar">Recuperar</a></p>
          <p>Não tem conta? <button type="button" className="link-button" onClick={onRegister}>Cadastrar</button></p>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
